import { render } from "./MetricsViewer.vue?vue&type=template&id=dfb0be9a&scoped=true&ts=true"
import script from "./MetricsViewer.vue?vue&type=script&lang=ts"
export * from "./MetricsViewer.vue?vue&type=script&lang=ts"

import "./MetricsViewer.vue?vue&type=style&index=0&id=dfb0be9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfb0be9a"]])

export default __exports__